import {asDdMmYyyy, momentFromIso8601} from "../shared/utils/date.utils";

export const createdAtColumn = (row: { createdAt: string }) => {
  return asDdMmYyyy(momentFromIso8601(row.createdAt)) ;
};
